import { Directive, AfterViewInit, ElementRef, inject } from '@angular/core';

@Directive({
    selector: 'input[appAutofocus], select[appAutofocus], textarea[appAutofocus]',
    standalone: false
})
export class AutofocusDirective implements AfterViewInit {
  private el = inject(ElementRef);


  ngAfterViewInit() {
    this.el.nativeElement.focus();
  }
}
